import Link from 'next/link';
import { PhoneCall, Mail, MapPin } from 'lucide-react';
import PhoneLink from './_components/phone-link';

const MobileNavbarFooter = () => {
  const mapRef =
    'https://maps.google.com/?q=6041+mcleod+dr+,+las+vegas+,+nv+89120';

  return (
    <div className="mt-6 flex w-full items-center justify-between px-3 text-white">
      <PhoneLink telNumber="7253045950">
        <PhoneCall size={28} />
      </PhoneLink>
      <Link
        href="&#109;a&#105;&#108;to&#58;&#115;&#37;6&#49;&#108;e&#37;73&#37;4&#48;&#114;mbi&#110;de%7&#50;y&#46;com?subject=Information%20Request&body=I%20would%20like%20to%20inquire%20about..."
        aria-label="e-mail link"
      >
        <Mail size={28} />
      </Link>
      <Link
        href={mapRef}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="e-mail link"
      >
        <MapPin size={28} />
      </Link>
    </div>
  );
};

export default MobileNavbarFooter;
